import { type Images } from '@neos/app'
import arrowRightPath from '../../modules/Global/images/ArrowRight.svg'
import collapsePath from '../../modules/dependencies/UserPermissions.3.2.8/images/Collapse.svg'
import communicationPath from '../../modules/Global/images/Communication.svg'
import copyPath from '../../modules/Global/images/Copy.svg'
import doubleArrowHorizontalPath from '../../modules/Global/images/DoubleArrowHorizontal.svg'
import doubleArrowVerticalPath from '../../modules/Global/images/DoubleArrowVertical.svg'
import downPath from '../../modules/dependencies/UserPermissions.3.2.8/images/Down.svg'
import draftPath from '../../modules/Global/images/Draft.svg'
import errorClusterPath from '../../modules/dependencies/UserPermissions.3.2.8/images/ErrorCluster.svg'
import expandPath from '../../modules/dependencies/UserPermissions.3.2.8/images/Expand.svg'
import externalClusterPath from '../../modules/dependencies/UserPermissions.3.2.8/images/ExternalCluster.svg'
import filterCollapsePath from '../../modules/Global/images/FilterCollapse.svg'
import filterExpandPath from '../../modules/Global/images/FilterExpand.svg'
import helpPath from '../../modules/Global/images/Help.svg'
import homePath from '../../modules/Global/images/Home.svg'
import logoEvoPath from '../../modules/WebSpace/images/LogoEvo.svg'
import logoSigabillColorPath from '../../modules/WebSpace/images/LogoSigabillColor.svg'
import minusPath from '../../modules/Global/images/Minus.svg'
import neosDataImportDetailPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportDetail.svg'
import neosDataImportDownloadFilePath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportDownloadFile.svg'
import neosDataImportErrorPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportError.svg'
import neosDataImportFilePath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportFile.svg'
import neosDataImportHistoryPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportHistory.svg'
import neosDataImportIntegratePath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportIntegrate.svg'
import neosDataImportIntegrateAllPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportIntegrateAll.svg'
import neosDataImportIntegrationPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportIntegration.svg'
import neosDataImportKpiErrorRowCountPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportKpiErrorRowCount.svg'
import neosDataImportKpiInformationRowCountPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportKpiInformationRowCount.svg'
import neosDataImportKpiIntegratedRowCountPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportKpiIntegratedRowCount.svg'
import neosDataImportKpiProcessedRowCountPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportKpiProcessedRowCount.svg'
import neosDataImportKpiValidRowCountPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportKpiValidRowCount.svg'
import neosDataImportKpiWarningRowCountPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportKpiWarningRowCount.svg'
import neosDataImportRightArrowPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportRightArrow.svg'
import neosDataImportRunPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportRun.svg'
import neosDataImportSettingsPath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportSettings.svg'
import neosDataImportTemplatePath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportTemplate.svg'
import neosDataImportUploadFilePath from '../../modules/dependencies/NeosDataExchange.3.2.8/images/NeosDataImportUploadFile.svg'
import newPath from '../../modules/Global/images/New.svg'
import openInNewSharpPath from '../../modules/Global/images/OpenInNewSharp.svg'
import paymentsPath from '../../modules/Global/images/Payments.svg'
import plusPath from '../../modules/Global/images/Plus.svg'
import previewPath from '../../modules/Global/images/Preview.svg'
import printPath from '../../modules/Global/images/Print.svg'
import rightPanelCollapsePath from '../../modules/Global/images/RightPanelCollapse.svg'
import rightPanelExpandPath from '../../modules/Global/images/RightPanelExpand.svg'
import roleUsersPath from '../../modules/dependencies/UserPermissions.3.2.8/images/RoleUsers.svg'
import rowInsertPath from '../../modules/Global/images/RowInsert.svg'
import syncBlackPath from '../../modules/dependencies/UserPermissions.3.2.8/images/SyncBlack.svg'
import testEnvironmentPath from '../../modules/Global/images/TestEnvironment.svg'
import upPath from '../../modules/dependencies/UserPermissions.3.2.8/images/Up.svg'
import userAccountPath from '../../modules/dependencies/UserPermissions.3.2.8/images/UserAccount.svg'
import userClientPath from '../../modules/dependencies/UserPermissions.3.2.8/images/UserClient.svg'
import userFunctionPath from '../../modules/dependencies/UserPermissions.3.2.8/images/UserFunction.svg'
import userPermissionsSendEmailPath from '../../modules/dependencies/UserPermissions.3.2.8/images/UserPermissionsSendEmail.svg'
import userPermissionsSendSMSPath from '../../modules/dependencies/UserPermissions.3.2.8/images/UserPermissionsSendSMS.svg'
import userPublisherPath from '../../modules/dependencies/UserPermissions.3.2.8/images/UserPublisher.svg'
import verticalDotsPath from '../../modules/Global/images/VerticalDots.svg'

const images: Images = {
  add: 'add',
  arrowRight: { path: arrowRightPath, colored: false },
  close: 'close',
  collapse: { path: collapsePath, colored: false },
  collapseControl: 'collapse',
  communication: { path: communicationPath, colored: false },
  copy: { path: copyPath, colored: false },
  doubleArrowHorizontal: { path: doubleArrowHorizontalPath, colored: false },
  doubleArrowVertical: { path: doubleArrowVerticalPath, colored: false },
  down: { path: downPath, colored: false },
  draft: { path: draftPath, colored: false },
  editUser: 'edit',
  error: 'error',
  errorCluster: { path: errorClusterPath, colored: true },
  expand: { path: expandPath, colored: false },
  expandControl: 'expand',
  externalCluster: { path: externalClusterPath, colored: true },
  filterCollapse: { path: filterCollapsePath, colored: false },
  filterExpand: { path: filterExpandPath, colored: false },
  help: { path: helpPath, colored: false },
  home: { path: homePath, colored: false },
  info: 'info',
  logoEvo: { path: logoEvoPath, colored: true },
  logoSigabillColor: { path: logoSigabillColorPath, colored: true },
  minus: { path: minusPath, colored: false },
  more: 'dotsHorizontal',
  neosDataImportAdd: 'add',
  neosDataImportClose: 'close',
  neosDataImportDetail: { path: neosDataImportDetailPath, colored: false },
  neosDataImportDownloadFile: { path: neosDataImportDownloadFilePath, colored: false },
  neosDataImportError: { path: neosDataImportErrorPath, colored: false },
  neosDataImportFile: { path: neosDataImportFilePath, colored: false },
  neosDataImportFilter: 'filter',
  neosDataImportHistory: { path: neosDataImportHistoryPath, colored: false },
  neosDataImportInfo: 'info',
  neosDataImportIntegrate: { path: neosDataImportIntegratePath, colored: false },
  neosDataImportIntegrateAll: { path: neosDataImportIntegrateAllPath, colored: false },
  neosDataImportIntegration: { path: neosDataImportIntegrationPath, colored: false },
  neosDataImportKpiErrorRowCount: { path: neosDataImportKpiErrorRowCountPath, colored: true },
  neosDataImportKpiInformationRowCount: { path: neosDataImportKpiInformationRowCountPath, colored: true },
  neosDataImportKpiIntegratedRowCount: { path: neosDataImportKpiIntegratedRowCountPath, colored: true },
  neosDataImportKpiProcessedRowCount: { path: neosDataImportKpiProcessedRowCountPath, colored: true },
  neosDataImportKpiValidRowCount: { path: neosDataImportKpiValidRowCountPath, colored: true },
  neosDataImportKpiWarningRowCount: { path: neosDataImportKpiWarningRowCountPath, colored: true },
  neosDataImportRightArrow: { path: neosDataImportRightArrowPath, colored: false },
  neosDataImportRun: { path: neosDataImportRunPath, colored: false },
  neosDataImportSettings: { path: neosDataImportSettingsPath, colored: false },
  neosDataImportTemplate: { path: neosDataImportTemplatePath, colored: false },
  neosDataImportUploadFile: { path: neosDataImportUploadFilePath, colored: false },
  neosDataImportValidate: 'validate',
  neosPrint: 'print',
  new: { path: newPath, colored: false },
  openInNewSharp: { path: openInNewSharpPath, colored: false },
  payments: { path: paymentsPath, colored: false },
  plus: { path: plusPath, colored: false },
  preview: { path: previewPath, colored: false },
  print: { path: printPath, colored: false },
  refresh: 'refresh',
  remove: 'remove',
  rightPanelCollapse: { path: rightPanelCollapsePath, colored: false },
  rightPanelExpand: { path: rightPanelExpandPath, colored: false },
  roleUsers: { path: roleUsersPath, colored: false },
  rowInsert: { path: rowInsertPath, colored: false },
  save: 'save',
  search: 'search',
  syncBlack: { path: syncBlackPath, colored: false },
  testEnvironment: { path: testEnvironmentPath, colored: false },
  up: { path: upPath, colored: false },
  userAccount: { path: userAccountPath, colored: false },
  userClient: { path: userClientPath, colored: false },
  userFunction: { path: userFunctionPath, colored: false },
  userPermissionsSendEmail: { path: userPermissionsSendEmailPath, colored: false },
  userPermissionsSendSMS: { path: userPermissionsSendSMSPath, colored: false },
  userPublisher: { path: userPublisherPath, colored: false },
  validate: 'validate',
  verticalDots: { path: verticalDotsPath, colored: false },
  warning: 'warning',
}

export default images